<div class="status-legend flex-row">
    <div class="grow-4"></div>
    <div class="status flex-row">
        <div class="operative"></div>
        <div class="status-name">{{ "operative" | lang }}</div>
    </div>

    <div class="status flex-row">
        <div class="delay"></div>
        <div class="status-name">{{ "delay" | lang }}</div>
    </div>

    <div class="status flex-row">
        <div class="reserve"></div>
        <div class="status-name">{{ "reserve" | lang }}</div>
    </div>

    <div class="status flex-row">
        <div class="out-of-service"></div>
        <div class="status-name">{{ "out_of_service" | lang }}</div>
    </div>
    <div class="grow-4"></div>
</div>
<div #chartTarget *ngIf="requestState"></div>
